import { render, staticRenderFns } from "./DirectPlacementGoalsInput.vue?vue&type=template&id=cac0e172"
import script from "./DirectPlacementGoalsInput.vue?vue&type=script&lang=js"
export * from "./DirectPlacementGoalsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports